import { useNotificationSettingsStore as useCoreNotificationSettingsStore, NotificationSettings } from '@flows.cash/core'
import { toast } from 'sonner'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'

export const useNotificationSettingsStore = () => {
  const { t } = useTranslation()
  const coreStore = useCoreNotificationSettingsStore()

  const updateSettings = useCallback(async (newSettings: Partial<NotificationSettings>) => {
    try {
      await coreStore.updateSettings(newSettings)
      toast.success(t('notificationSettings.updateSuccess'))
    } catch (error) {
      toast.error(t('notificationSettings.updateError'))
      throw error
    }
  }, [coreStore.updateSettings, t])

  const resetSettings = useCallback(async () => {
    try {
      await coreStore.resetSettings()
      toast.success(t('notificationSettings.resetSuccess'))
    } catch (error) {
      toast.error(t('notificationSettings.resetError'))
      throw error
    }
  }, [coreStore.resetSettings, t])

  const loadSettings = useCallback(async () => {
    try {
      await coreStore.loadSettings()
    } catch (error) {
      toast.error(t('notificationSettings.loadError'))
      throw error
    }
  }, [coreStore.loadSettings, t])

  return {
    ...coreStore,
    updateSettings,
    resetSettings,
    loadSettings
  }
} 